import axios from 'axios';

const clientV1 = axios.create({
	baseURL: process.env.REACT_APP_BASE_URL,
	responseType: 'json'
});

const clientV2 = axios.create({
	baseURL: process.env.REACT_APP_NESTJS_BASE_URL,
	responseType: 'json',
});

export { clientV1, clientV2 };